import Dashboard from './Dashboard';
import Profile from './Profile';
import ChangePassword from './components/ChangePassword'
import Agenda from './widgets/Agenda';
import StudentCourseDashboard from './StudentCourseDashboard';
import InstructorCourseDashboard from './InstructorCourseDashboard';
import UnverifiedUserPasswordForm from './UnverifiedUserPasswordForm';

export const DashboardConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/dashboard',
            component: Dashboard
        },
        {
            path: '/profile',
            component: Profile
        },
        {
            path: '/password_verify',
            component: UnverifiedUserPasswordForm
        },
        {
            path: '/change-password',
            component: ChangePassword
        },
        {
            path: '/calendar_test',
            component: Agenda
        },
        {
            path: '/course-dashboard/:company_calendar_course_id/:unscheduled',
            component: StudentCourseDashboard
        },
        {
            path: '/instructor-course-dashboard/:company_calendar_course_id/:unscheduled',
            component: InstructorCourseDashboard
        },
    ]
};



// WEBPACK FOOTER //
// src/main/content/dashboard/DashboardConfig.js